
import Vue from 'vue';
import { autoTranslate } from '@/helpers/autoTranslate';

export default Vue.extend({
  props: {
    input: { type: Object, default: () => {} },
    data: { type: Object, default: () => {} },
    getVariable: { type: Function, default: () => () => {} },
    callFunction: { type: Function, default: () => () => {} },
    onChange: { type: Function, default: () => {} },
    parent: { type: Object, default: () => {} },
    rowDisabled: { type: Boolean, default: false }
  },
  data: () => { return { menu: false, date: '' } },
  computed: {
    minDate: function(): string {
      if(!this.input.minDateFormula) return '';
      const minDate = this.parent._resolveFormulaValue(this.input.minDateFormula);
      return minDate || '';
    },
    maxDate: function(): string {
      if(!this.input.maxDateFormula) return '';
      const maxDate = this.parent._resolveFormulaValue(this.input.maxDateFormula);
      return maxDate || '';
    },
    autoTranslatedLabel: function(): string {
      return autoTranslate(this.input.label);
    }
  },
  watch: {
    date() {
      const { prefix, key } = this.parent._getPrefixAndKey(this.input.variable);
      if(!this.getVariable(prefix)) {
        const { prefix: parentPrefix, key: parentKey } = this.parent._getPrefixAndKey(prefix);
        this.$set(this.getVariable(parentPrefix), parentKey, {});
        this.$set(this.getVariable(prefix), key, this.date);
      } else {
        this.$set(this.getVariable(prefix), key, this.date);
      }
      if(this.onChange) this.onChange(this.input.onChange,{ selectedObject: this.getVariable(this.input.variable)});
    }
  },
  mounted() {
    this.$watch(
      () => this.getVariable(this.input.variable), 
      (dateVariable) => {
        if (this.date !== dateVariable) {
          this.date = dateVariable ? dateVariable.substr(0, 10) : '';
        }
      },
      { immediate: true }
    );
  }
})
